import type { EntityItemInterface } from 'src/app/shared/components/search-input/select-item.interface';
import type { ClinicInterface } from 'src/app/shared/models/clinic.interface';
import type { UserInterface } from 'src/app/shared/models/user.interface';

export enum UserRoleEnum {
  ADMIN,
  ORTHANC,
  VETERINARY,
  SECRETARY,
  CLIENT,
  CLINIC_ADMIN,
  INVITED_VET,
  RADIOLOGIST,
  SCC_VETERINARY,
  SCC_REVIEWER,
  ADMIN_SCC,
  PMS_DEVELOPER
}

export interface UserDtoInterface {
  firstName: string;
  lastName: string;
  email: string;
  locale: string;
  password: string;
  clinicIds: number[];
  roles: string[];
  signature: string;
  orderNum: string;
}

export interface EditUserResultInterface {
  user: UserDtoInterface;
  clinics: EntityItemInterface[];
}

export interface UserAndClinicsInterface {
  user: UserInterface;
  clinics: EntityItemInterface[];
}

export interface UserDetailsInterface {
  id?: number;
  firstName: string;
  lastName: string;
  email: string;
  locale?: string;
  password?: string;
  roles: string[];
  clinics: ClinicInterface[];
  signature?: string;
  orderNum?: string;
}

export interface UserShortInterface {
  firstName: string;
  lastName: string;
}
